import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'confirm-bulk-edits-modal',
  templateUrl: 'confirm-bulk-edits-modal.component.html',
  styleUrls: ['confirm-bulk-edits-modal.component.scss'],
})
export class ConfirmBulkEditsModalComponent extends BaseModalComponent {
  @Input() size: number;

  @Input() segment: string;

  @Output() confirm: EventEmitter<any> = new EventEmitter();

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  get noteText(): string {
    switch (this.segment) {
      case 'description':
        return `You are about to edit ${this.size} items, are you sure you wish to update all edited values?`;
      default:
        return `You are about to edit ${this.size} items, are you sure you wish to overwrite all edited values?`;
    }
  }

  onCancelClick() {
    this.cancel.emit();
  }

  onConfirmClick() {
    this.confirm.emit();
  }
}
